import { LoadingOutlined } from "@ant-design/icons";
import { useProductActions } from "_actions/product.actions";
import { Breadcrumb, Button, message, Spin } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const ReportsPage = () => {
  const productActions = useProductActions();
  const [isLoading, setIsLoading] = useState(true);
  const [smallcases, setSmallcases] = useState([]);

  useEffect(() => {
    // Fetch products
    setIsLoading(true);
    productActions
      .discoverSmallcases()
      .then(
        (response) => {
          setSmallcases(response.data.data.smallcases);
        },
        (error) => {
          console.error(error);
          message.error("Failed to fetch Smallcase products");
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <Spin indicator={<LoadingOutlined spin />} size="large" />
      </div>
    );
  return (
    <section className="mx-auto space-y-5">
      <Breadcrumb
        items={[
          {
            title: <Link to="/">Home</Link>,
          },
          {
            title: "Reports",
          },
        ]}
      />
      <div className="text-slate-500 text-center space-y-5">
        {smallcases.map((item: any, index: number) => (
          <div
            key={index}
            className="grid lg:grid-cols-6 items-center gap-8 bg-white rounded-lg p-4 hover:text-black"
          >
            <div className="flex gap-4 col-span-5 items-center text-sm font-medium px-3">
              <img
                src={item.info.imageUrl}
                alt={item.info.name}
                width={80}
                className="w-20 h-20"
              />
              <div className="text-start">
                <h3 className="text-lg font-semibold pb-2">
                  {item.info.name} Factsheet
                </h3>
                <p className="text-xs">{item.info.shortDescription}</p>
                {/* <p className="text-xs">{item.info.shortDescription}</p> */}
              </div>
            </div>

            <div className="text-center">
              <Button
                type="primary"
                className="font-bold text-xs px-8"
                href={`https://assets.smallcase.com/factsheets/${item.scid}.pdf`}
                target="_blank"
              >
                View Now
              </Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
